module.exports = __webpack_public_path__ + "static/media/easy-sushi.5e9accc2.png";